/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  GetUserPublicKeyQueryResponse,
  GetUserPublicKeyPathParams,
  GetUserPublicKey401,
  GetUserPublicKey404,
} from "../types/GetUserPublicKey.ts"
import { getUserPublicKeyQueryResponseSchema } from "../zod/getUserPublicKeySchema.ts"

function getGetUserPublicKeyUrl(id: GetUserPublicKeyPathParams["id"]) {
  const res = { method: "GET", url: `/users/${id}/publickey` as const }
  return res
}

/**
 * @summary Get a user's public key by ID
 * {@link /users/:id/publickey}
 */
export async function getUserPublicKey(
  id: GetUserPublicKeyPathParams["id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetUserPublicKeyQueryResponse,
    ResponseErrorConfig<GetUserPublicKey401 | GetUserPublicKey404>,
    unknown
  >({
    method: "GET",
    url: getGetUserPublicKeyUrl(id).url.toString(),
    ...requestConfig,
  })
  return getUserPublicKeyQueryResponseSchema.parse(res.data)
}
